import * as Yup from 'yup';
import { getRequiredText } from '../../../../global/helpers/transformer';
import { LabelSettingProps } from '../../../../global/models/epi-model';
import { PersonPhoneValues } from '../../../../global/models/person-model';
import { PersonInfoValidationSchema } from '../../../../global/validation-schemas/account-information-form-validation';
import { PersonInfoMailingAddressValidationSchema } from '../../../../global/validation-schemas/address-form-validation';
import { RelationshipsProps } from '../../models/account-info-epi-props';

export function ConfirmationMarriedValidationSchema(labelSetting: LabelSettingProps, relationshipsProps: RelationshipsProps) {
    const maritalStatusShape = {
        marital_status: Yup.string().required(getRequiredText(labelSetting.requiredFormat, relationshipsProps.maritalStatusLabel)),
        marital_status_effective_date: Yup.date().nullable().required(getRequiredText(labelSetting.requiredFormat, relationshipsProps.dateOfMarriageLabel))
            .max(new Date(Date.now()), labelSetting.dateFutureError || 'Date cannot be in the future'),
        attestation1: Yup.boolean().required(getRequiredText(labelSetting.requiredFormat, relationshipsProps.attestationRequiredMessage1 || 'Attestation'))
            .oneOf([true], getRequiredText(labelSetting.requiredFormat, relationshipsProps.attestationRequiredMessage1 || 'Attestation')),
        attestation2: Yup.boolean().required(getRequiredText(labelSetting.requiredFormat, relationshipsProps.attestationRequiredMessage2 || 'Attestation'))
            .oneOf([true], getRequiredText(labelSetting.requiredFormat, relationshipsProps.attestationRequiredMessage2 || 'Attestation')),
    };

    return maritalStatusShape;
}

export const MarriedValidationSchema =
    (labelSetting: LabelSettingProps,
        relationshipsProps: RelationshipsProps,
        spouseIsClergy: boolean,
        adminSingleToMarried: boolean,
        confirmationPage: boolean,
        dobValue: string,
        personPhoneValues: PersonPhoneValues) => {

        let schema: Yup.ObjectSchema<any>;

        const maritalStatusShape = ConfirmationMarriedValidationSchema(labelSetting, relationshipsProps);

        if (confirmationPage) {
            schema = Yup.object().shape(maritalStatusShape);
        } else {
            schema = Yup.object().shape({
                ...PersonInfoValidationSchema(labelSetting, dobValue, personPhoneValues),
                ...PersonInfoMailingAddressValidationSchema(labelSetting),
            });

            if (spouseIsClergy) {
                schema = schema.shape({
                    designation_salutation: Yup.string().required(getRequiredText(labelSetting.requiredFormat, labelSetting.salutationLabel)),
                });
            }

            // validate marital status fields if not going from single to married in ARC
            if (!adminSingleToMarried) {
                schema = Yup.object().shape(
                    {
                        ...PersonInfoValidationSchema(labelSetting, dobValue, personPhoneValues),
                        ...PersonInfoMailingAddressValidationSchema(labelSetting),
                        ...maritalStatusShape,
                    });
            }
        }

        return schema;
    };

export const NotMarriedValidationSchema = (labelSetting: LabelSettingProps, relationshipsProps: RelationshipsProps, isReportingSpouseDeath: boolean, isReportingDivorce?: boolean) => {

    let schema: Yup.ObjectSchema<any>;

    schema = Yup.object().shape({
        marriage_end_date: Yup.date().nullable().required(getRequiredText(labelSetting.requiredFormat, relationshipsProps.endOfMarriageLabel))
            .max(new Date(Date.now()), labelSetting.dateFutureError || 'Date cannot be in the future'),
        attestation1: Yup.boolean().required(getRequiredText(labelSetting.requiredFormat, relationshipsProps.attestationRequiredMessage1))
            .oneOf([true], getRequiredText(labelSetting.requiredFormat, relationshipsProps.attestationRequiredMessage1)),

    });

    if (isReportingDivorce) {
        schema = schema.shape({
            marriage_end_date: Yup.date().nullable().required(getRequiredText(labelSetting.requiredFormat, relationshipsProps.endOfMarriageLabel))
                .max(new Date(Date.now()), labelSetting.dateFutureError || 'Date cannot be in the future'),
            attestation1: Yup.boolean().required(getRequiredText(labelSetting.requiredFormat, relationshipsProps.attestationRequiredMessage1))
                .oneOf([true], getRequiredText(labelSetting.requiredFormat, relationshipsProps.attestationRequiredMessage1)),
            attestation2: Yup.boolean().required(getRequiredText(labelSetting.requiredFormat, relationshipsProps.attestationRequiredMessage2))
                .oneOf([true], getRequiredText(labelSetting.requiredFormat, relationshipsProps.attestationRequiredMessage2)),
            court_issuing: Yup.string().nullable().required(getRequiredText(labelSetting.requiredFormat, relationshipsProps.courtIssuingDecreeRequiredMessage)),
            case_number: Yup.string().nullable().required(getRequiredText(labelSetting.requiredFormat, relationshipsProps.caseNumberRequiredMessage)),
        });
    }


    if (!isReportingSpouseDeath) {
        schema = schema.shape({
            attestation2: Yup.boolean().required(getRequiredText(labelSetting.requiredFormat, relationshipsProps.attestationRequiredMessage2))
                .oneOf([true], getRequiredText(labelSetting.requiredFormat, relationshipsProps.attestationRequiredMessage2)),
        });
    }

    return schema;
};